import type { PosSalesLayoutDocument } from "../gateway/sales-layout-client";

/** Shared Layout presentation semantics; no local greeting or tenant fallback. */
export function salesHeaderMessage(document: PosSalesLayoutDocument | null): string | null {
  const value = document?.header_message;
  if (!value || value.enabled !== true || typeof value.text !== "string") return null;
  if (!value.text.trim() || Array.from(value.text).length > 200 || /[\u0000-\u001f\u007f<>]/u.test(value.text)) return null;
  return value.text;
}
